// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__aZeVN","mail_link":"Footer_mail_link__GnoCW","logo_icon":"Footer_logo_icon__T8VQ3","logo_link":"Footer_logo_link__CL10m"};